<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="520"
        :fullscreen="isMobile" persistent @keydown.esc="chiudi">
        <v-card>
            <v-card-title>{{ form.id ? 'Modifica cambio gomme' : 'Registra cambio gomme' }}</v-card-title>
            <v-card-text>
                <v-form ref="formRef">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.data" type="date" label="Data del cambio" :max="oggiIso"
                                :rules="[v => !!v || 'Campo obbligatorio']" />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select v-model="form.stagione" :items="stagioni" item-title="label"
                                item-value="value" label="Gomme montate"
                                :rules="[v => !!v || 'Campo obbligatorio']" />
                        </v-col>
                    </v-row>
                    <v-text-field v-model="form.eseguitoDa" label="Eseguito da (officina / persona)" class="mb-2" />
                    <v-switch v-model="form.nuoveAcquistate" color="primary" label="Gomme nuove acquistate"
                        hide-details class="mb-2" />
                    <v-text-field v-model.number="form.km" type="number" label="Km del mezzo (facoltativo)" />
                    <v-textarea v-model="form.note" label="Note" rows="2" />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="primary" :loading="salvataggio" @click="salva">Salva</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogCambioGomme",

    props: {
        modelValue: { type: Boolean, default: false },
        mezzoId: { type: [Number, String], required: true },
        cambio: { type: Object, default: null },
    },
    emits: ["update:modelValue", "salvato"],

    data() {
        return {
            form: this.formVuoto(),
            salvataggio: false,
            stagioni: [
                { label: "Invernali", value: "Invernali" },
                { label: "Estive", value: "Estive" },
                { label: "4 stagioni", value: "QuattroStagioni" },
            ],
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        oggiIso() {
            return this.oggiLocale();
        },
    },

    watch: {
        modelValue(val) {
            if (val) this.inizializza();
        },
    },

    methods: {
        // Data locale (non toISOString: in UTC sposterebbe il giorno vicino alla mezzanotte).
        oggiLocale() {
            const d = new Date();
            const m = String(d.getMonth() + 1).padStart(2, "0");
            const g = String(d.getDate()).padStart(2, "0");
            return `${d.getFullYear()}-${m}-${g}`;
        },

        formVuoto() {
            return {
                id: null,
                data: this.oggiLocale(),
                stagione: null,
                eseguitoDa: "",
                nuoveAcquistate: false,
                km: null,
                note: "",
            };
        },

        inizializza() {
            this.form = this.cambio
                ? {
                    id: this.cambio.id,
                    data: this.cambio.data ? this.cambio.data.substr(0, 10) : this.oggiLocale(),
                    stagione: this.cambio.stagione,
                    eseguitoDa: this.cambio.eseguitoDa || "",
                    nuoveAcquistate: !!this.cambio.nuoveAcquistate,
                    km: this.cambio.km,
                    note: this.cambio.note || "",
                }
                : this.formVuoto();
        },

        async salva() {
            const { valid } = await this.$refs.formRef.validate();
            if (!valid) return;

            this.salvataggio = true;
            try {
                const { id, ...dati } = this.form;
                dati.mezzoId = this.mezzoId;
                dati.km = dati.km === "" ? null : dati.km;
                await this.$store.dispatch("cambiGomme/salva", { id, dati, mezzoId: this.mezzoId });
                this.$emit("salvato");
                this.chiudi();
            } catch (error) {
                console.log(error);
            }
            this.salvataggio = false;
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },
    },
};
</script>
